export { initials } from '@shared/format';

export function timeAgo(date: Date | number, now: Date = new Date()): string {
  const ms = now.getTime() - (typeof date === 'number' ? date : date.getTime());
  const mins = Math.floor(ms / 60000);
  if (mins < 2) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

type DateLike = Date | { toDate(): Date } | null | undefined;

export function formatDate(value: DateLike, opts: { withTime?: boolean } = {}): string {
  if (!value) return '—';
  const d = value instanceof Date ? value : value.toDate();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  const base = `${mm}/${dd}/${yyyy}`;
  if (!opts.withTime) return base;
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${base} ${hh}:${mi}`;
}
